import React from "react";
import { motion } from "framer-motion";

// Radar Chart Component
const RadarChart = ({ data }) => {
  const size = 400;
  const center = size / 2;
  const radius = 140;
  const labelRadius = 180;

  const points = data.map((item, index) => {
    const angle = (index / data.length) * 2 * Math.PI - Math.PI / 2;
    const r = (item.score / 10) * radius;
    const labelX = center + Math.cos(angle) * labelRadius;
    const labelY = center + Math.sin(angle) * labelRadius;

    return {
      ...item,
      angle,
      x: center + Math.cos(angle) * r,
      y: center + Math.sin(angle) * r,
      label: { x: labelX, y: labelY },
    };
  });

  const path =
    points
      .map((point, i) => `${i === 0 ? "M" : "L"} ${point.x} ${point.y}`)
      .join(" ") + " Z";

  return (
    <div className="flex justify-center">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="w-full h-auto max-w-md"
      >
        {[2, 4, 6, 8, 10].map((value) => (
          <circle
            key={value}
            cx={center}
            cy={center}
            r={(value / 10) * radius}
            fill="none"
            stroke="rgba(255, 255, 255, 0.1)"
            strokeWidth="1"
          />
        ))}

        {points.map((point, index) => (
          <line
            key={index}
            x1={center}
            y1={center}
            x2={center + Math.cos(point.angle) * radius}
            y2={center + Math.sin(point.angle) * radius}
            stroke="rgba(255, 255, 255, 0.1)"
            strokeWidth="1"
          />
        ))}

        <motion.path
          d={path}
          fill="rgba(220, 255, 2, 0.2)"
          stroke="#dcff02"
          strokeWidth="2"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
        />

        {points.map((point, index) => (
          <motion.circle
            key={index}
            cx={point.x}
            cy={point.y}
            r="4"
            fill="#dcff02"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.8 + index * 0.1 }}
          />
        ))}

        {points.map((point, index) => (
          <motion.text
            key={index}
            x={point.label.x}
            y={point.label.y}
            textAnchor="middle"
            dominantBaseline="central"
            className="text-xs font-medium fill-white"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 + index * 0.1 }}
          >
            {point.name}
          </motion.text>
        ))}
      </svg>
    </div>
  );
};

export default RadarChart;
